<form
  [formGroup]="linkForm"
  (keydown.enter)="$event.preventDefault(); insert()"
  (keydown.escape)="cancel()"
  class="flex flex-col gap-md p-lg bg-white rounded-lg shadow-lg min-w-[17.5rem]">
  <h3 class="text-base font-semibold text-neutral-900 m-0">
    {{ 'rich_text_link_insert_title' | transloco }}
  </h3>

  <div>
    <lib-input
      inputFormControlName="displayName"
      id="linkDisplayName"
      type="text"
      name="displayName"
      [label]="'rich_text_link_display_name_label' | transloco"
      [placeholder]="'rich_text_link_display_name_placeholder' | transloco"
      [required]="true" />
    <lib-validation-message
      [lang]="currentLang"
      [label]="'rich_text_link_display_name_label' | transloco"
      control="displayName" />
  </div>

  <div>
    <lib-input
      inputFormControlName="url"
      id="linkUrl"
      type="url"
      name="url"
      [label]="'rich_text_link_url_label' | transloco"
      [placeholder]="'rich_text_link_url_placeholder' | transloco"
      [required]="true" />
    <lib-validation-message
      [lang]="currentLang"
      [label]="'rich_text_link_url_label' | transloco"
      control="url"
      [customErrorMessages]="{
        invalidUrl: 'rich_text_link_url_error_message' | transloco,
      }" />
  </div>

  <div class="flex justify-end gap-sm mt-sm">
    <button
      type="button"
      class="px-lg py-sm rounded-md text-neutral-700 bg-white text-sm font-medium border border-neutral-300 cursor-pointer hover:bg-neutral-50 transition-colors"
      (click)="cancel()">
      {{ 'rich_text_link_cancel_button' | transloco }}
    </button>
    <button
      type="button"
      class="px-lg py-sm rounded-md text-white bg-primary-400 text-sm font-medium border-none cursor-pointer hover:bg-primary-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      [disabled]="linkForm.invalid"
      (click)="insert()">
      {{ 'rich_text_link_insert_button' | transloco }}
    </button>
  </div>
</form>
